import { OnsiteMessage, PLUpsellWrapper, UpsellWrapper, ZestimateOffer, ButtonUpsell, DualHookShowcaseUpsell, SellForMoreShowcaseUpsell } from '@zillow/zrs-cms-messaging';
export { getOMPDisplayStatus } from '@zillow/zrs-cms-messaging';
import React from 'react';
import PropTypes from 'prop-types';

var NFSOnsiteMessagingWrapper = function NFSOnsiteMessagingWrapper(_ref) {
  var _ref$messageData = _ref.messageData,
    messageData = _ref$messageData === void 0 ? {} : _ref$messageData,
    _ref$placementName = _ref.placementName,
    placementName = _ref$placementName === void 0 ? 'NFSHDPTopSlot' : _ref$placementName,
    additionalProps = _ref.additionalProps,
    _ref$additionalClickS = _ref.additionalClickStreamData,
    additionalClickStreamData = _ref$additionalClickS === void 0 ? {} : _ref$additionalClickS,
    _ref$triggerLocation = _ref.triggerLocation,
    triggerLocation = _ref$triggerLocation === void 0 ? '' : _ref$triggerLocation,
    _ref$triggerObject = _ref.triggerObject,
    triggerObject = _ref$triggerObject === void 0 ? '' : _ref$triggerObject,
    _ref$triggerSource = _ref.triggerSource,
    triggerSource = _ref$triggerSource === void 0 ? '' : _ref$triggerSource;
  return /*#__PURE__*/React.createElement(OnsiteMessage, {
    messageData: messageData,
    placementName: placementName,
    additionalProps: additionalProps,
    additionalClickStreamData: additionalClickStreamData,
    supportedComponents: {
      PLUpsellWrapper: PLUpsellWrapper,
      UpsellWrapper: UpsellWrapper,
      ZestimateOffer: ZestimateOffer,
      ButtonUpsell: ButtonUpsell,
      DualHookShowcaseUpsell: DualHookShowcaseUpsell,
      SellForMoreShowcaseUpsell: SellForMoreShowcaseUpsell
    },
    triggerLocation: triggerLocation,
    triggerObject: triggerObject,
    triggerSource: triggerSource
  });
};
NFSOnsiteMessagingWrapper.hdpFeatureName = 'NFS HDP Onsite Messaging';
var ONSITE_MESSAGING_FRAGMENT = {
  "kind": "Document",
  "definitions": [{
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "onsiteMessage_fragment"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "OnsiteMessageResultType"
      }
    },
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "eventId"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "decisionContext"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "messages"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "skipDisplayReason"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "shouldDisplay"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "isGlobalHoldout"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "isPlacementHoldout"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "placementName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "testPhase"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "bucket"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "placementId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "passThrottle"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastModified"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "eventId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "decisionContext"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "selectedTreatment"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "component"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "status"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "renderingProps"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "lastModified"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "qualifiedTreatments"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "status"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "lastModified"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 780,
    "source": {
      "body": "\n    fragment onsiteMessage_fragment on OnsiteMessageResultType {\n        eventId\n        decisionContext\n        messages {\n            skipDisplayReason\n            shouldDisplay\n            isGlobalHoldout\n            isPlacementHoldout\n            placementName\n            testPhase\n            bucket\n            placementId\n            passThrottle\n            lastModified\n            eventId\n            decisionContext\n            selectedTreatment {\n                id\n                name\n                component\n                status\n                renderingProps\n                lastModified\n            }\n            qualifiedTreatments {\n                id\n                name\n                status\n                lastModified\n            }\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
NFSOnsiteMessagingWrapper.propTypes = {
  placementName: PropTypes.string,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  messageData: PropTypes.shape({
    eventId: PropTypes.string,
    decisionContext: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.shape({
      skipDisplayReason: PropTypes.string,
      shouldDisplay: PropTypes.bool,
      isGlobalHoldout: PropTypes.bool,
      isPlacementHoldout: PropTypes.bool,
      placementName: PropTypes.string,
      testPhase: PropTypes.string,
      bucket: PropTypes.string,
      placementId: PropTypes.number,
      passThrottle: PropTypes.bool,
      lastModified: PropTypes.string,
      eventId: PropTypes.string,
      decisionContext: PropTypes.string,
      selectedTreatment: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        component: PropTypes.string,
        status: PropTypes.string,
        rendringProps: PropTypes.string,
        lastModified: PropTypes.string
      }),
      qualifiedTreatments: PropTypes.arrayOf(PropTypes.shape({
        component: PropTypes.string,
        id: PropTypes.number,
        lastModified: PropTypes.string,
        name: PropTypes.string,
        renderingProps: PropTypes.string,
        status: PropTypes.string
      }))
    }))
  }),
  additionalClickStreamData: PropTypes.object,
  triggerLocation: PropTypes.string,
  triggerObject: PropTypes.string,
  triggerSource: PropTypes.string
};
var NFSOnsiteMessagingWrapper$1 = NFSOnsiteMessagingWrapper;

export { NFSOnsiteMessagingWrapper$1 as NFSOnsiteMessagingWrapper, ONSITE_MESSAGING_FRAGMENT };
